/** declared local storage keys */
export enum LocalStorageKey {
  MainMenuState = 'isp_main_menu_state',
  MainMenuFilter = 'isp_main_menu_filter',
  Tablist = 'isp_tab-list',
  CodeEditorSettings = 'isp_code_editor_settings',
  UsefulLinks = 'isp_useful_links',
  ColorScheme = 'isp_color_scheme',
}
